module.exports = "static/assets/d1f6af6170e0178514f35fedc62e5eab.svg";